import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { Router } from "@angular/router";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"]
})
export class HomeComponent implements OnInit {
  searchListPage="/home/carbon-footprint";
  searchPage="/home/GSF/eng/energy";
  constructor(private readonly titleService: Title,
              private readonly router: Router) {
    if (this.router.url.indexOf("/home/people") !== -1) {
      titleService.setTitle("People - Responsible Recruitment");
    } else if(this.router.url.indexOf("/home/commodities") !== -1) {
      titleService.setTitle("Commodities")
    }else if(this.router.url.indexOf(this.searchListPage) !== -1) {
      titleService.setTitle("Carbon Footprint");
    }else {
      titleService.setTitle("Gigaton Calculator");
    }
    (window as any).adobeDataLayer.push({
      page: {
        pageName: this.titleService.getTitle()
      }
    });
  }

  ngOnInit() {}

  public isPeopleRouteActive(): boolean {
    const URL = "/home/people";
    return this.router.isActive(this.router.parseUrl(URL), false);
  }

  public isGigatonRoute(): boolean {
    const URL = "/home/GSF";
    return this.router.isActive(this.router.parseUrl(URL), false);
  }
   public isCarbonFootprintRoute(): boolean {
    const URL = this.searchListPage;
    return this.router.isActive(this.router.parseUrl(URL), false);
   }

}
